__turbopack_context__.v({
  "className": "syne_f4082a90-module__JKDXuG__className",
  "variable": "syne_f4082a90-module__JKDXuG__variable",
});
